import { RedoFeatureNotificationCard } from "@redotech/redo-web/arbiter-components/feature-notification/redo-feature-notification-card";
import { memo } from "react";
import { OnboardingProps } from "../common";
import { CROSS_SELL_POPUP_URL } from "../index";

export const HelpIconMovingOnboarding = memo(function HelpIconMovingOnboarding({
  handleDismiss,
  handleComplete,
}: OnboardingProps) {
  return (
    <RedoFeatureNotificationCard
      actionText="Got it"
      description="Click here to get help!"
      image={`${CROSS_SELL_POPUP_URL}/help-icon-moving.png`}
      onAction={handleComplete}
      onDismiss={handleDismiss}
      title="The help icon has moved"
    />
  );
});
